import { render, staticRenderFns } from "./stockRegisterAction.vue?vue&type=template&id=22a7b4ee&scoped=true"
import script from "./stockRegisterAction.vue?vue&type=script&lang=js"
export * from "./stockRegisterAction.vue?vue&type=script&lang=js"
import style0 from "./stockRegisterAction.vue?vue&type=style&index=0&id=22a7b4ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a7b4ee",
  null
  
)

export default component.exports